import { LevelData } from '../level-data';

export const level13: LevelData = {
    name: 'Long Jump',
    timeLimit: 100,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
